import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment Subscription on subscriptions {
    id
    status
    start_date
    end_date
    installment_amount
    installments
    total
    plan_id
    signup_fee
    stripe_customer_id
    stripe_subscription_id
    tier_prices
    cancelled_at  
  }
  fragment Product on products {
    id
    package_name
    contract_filename
    pricing_model
    product_type
    graduation_year
    trial_days  
    config  
  }
  fragment Student on users {
    user_id
    user_first_name
    user_last_name
  }
`;
export const GET_SUBS = gql`
  query getSubsriptions($query: String, $offset: Int) {
    subscriptions(
      where: {
        status: { _neq: "payment_pending" }
        student_id: { _is_null: false }
        _or: [
          { product: { package_name: { _ilike: $query } } }
          { student: { user_first_name: { _ilike: $query } } }
          { student: { user_last_name: { _ilike: $query } } }
        ]
      }
      limit: 10
      offset: $offset
    ) {
      ...Subscription
      product {
        ...Product
      }
      student {
        ...Student
      }
    }
    count: subscriptions_aggregate(
      where: { 
          status: { _neq: "payment_pending" }
          student_id: { _is_null: false }
          _or: [
              { product: { package_name: { _ilike: $query } } }
              { student: { user_first_name: { _ilike: $query } } }
              { student: { user_last_name: { _ilike: $query } } }
          ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
  ${FRAGMENTS}
`;

export const UPDATE_SUB = gql`
    mutation update($id: Int!, $data: subscriptions_set_input!) {
        row: update_subscriptions_by_pk(pk_columns: {id: $id}, _set: $data) {
            ...Subscription
            product {
                ...Product
            }
            student {
                ...Student
            }
        }
    }
    ${FRAGMENTS}
`;

export const GET_USERS_WITHOUT_SUB = gql`
    query getStudents($query: String) {
        v_students(where: {_or: [{user_first_name: {_ilike: $query}}, {user_last_name: {_ilike: $query}}, {user_email: {_ilike: $query}}]}, limit: 10) {
            user_id
            user_last_name
            user_first_name
            user_email
            has_active_subscription
        }
    }
`;

export const ADD_SUB = gql`
  mutation addSub($data: subscriptions_insert_input!) {
    insert_subscriptions_one(object: $data) {
      ...Subscription
      product {
        ...Product
      }
      student {
        ...Student
      }
    }
  }
  ${FRAGMENTS}
`;
